import {  getQueryParams, httpApi } from '@api/FW/http.api';
import { serviceWalletsAdapter } from '@api/FW/serviceWallets/adapter';
import { IServiceWallet, IServiceWalletDTO } from '@api/FW/serviceWallets/types';

/**
 * Fetch user service wallets for one or more counterparties.
 *
 * The counterparty (`client.counterparty`) is appended to the URL, e.g.
 * `ServiceWallets/2b9de9c1-5755-11f0-a7a9-005056b9032b`. Multiple
 * counterparties are joined with `/`.
 */
export const getServiceWallets = (
	counterparty?: string | string[],
): Promise<IServiceWallet[]> => {
	const counterparties = Array.isArray(counterparty) ? counterparty.join('/') : counterparty;
	const endpoint = counterparties ? `ServiceWallets/${counterparties}` : 'ServiceWallets';

	return httpApi
		.get<IServiceWalletDTO[]>(endpoint, {
			params: { ...getQueryParams() },
		})
		.then(({ data }) => {
			return serviceWalletsAdapter(data);
		})
		.catch((err) => {
			throw err;
		});
};
